import React, { useState } from 'react';
import { BOTTOM_INDENTS, validateDebounce, VALIDATION_RULES } from '@constants';
import { ACCOUNT_USER_ROLE } from '@enums';
import { useStore } from '@hooks';
import { Button, Input, Select, Typography } from '@ui';
import { Col, Flex, Form, Row, Spin } from 'antd';
import { observer } from 'mobx-react';
import { ACCOUNT_USER_ROLE_LABELS } from '../../../../constants';
import { StyledCard } from './styled';

const MemberForm = observer(({ onCancel }) => {
    const store = useStore();
    const { handleTeamMemberCreate } = store.accountsStore;
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const onFinish = async (member) => {
        setIsLoading(true);
        try {
            await handleTeamMemberCreate(member, onCancel);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <StyledCard data-e2e='team-management_new-staff-account_form'>
            <Spin spinning={isLoading}>
                <Form preserve={false} form={form} onFinish={onFinish}>
                    <Typography.Title level={3} style={BOTTOM_INDENTS.M}>
                        New staff account
                    </Typography.Title>
                    <Row gutter={[16, 16]} style={BOTTOM_INDENTS.M}>
                        <Col span={12}>
                            <Form.Item
                                name='firstName'
                                onBlur={(e) => form.setFieldValue('firstName', e.target.value.trim())}
                            >
                                <Input label='First Name' data-e2e='team-management_first-name_input' />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name='lastName'
                                onBlur={(e) => form.setFieldValue('lastName', e.target.value.trim())}
                            >
                                <Input label='Last Name' data-e2e='team-management_last-name_input' />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name='email'
                                rules={[...VALIDATION_RULES.REQUIRED, ...VALIDATION_RULES.EMAIL]}
                                validateDebounce={validateDebounce}
                                normalize={(value) => value?.trim()}
                            >
                                <Input label='Email address' data-e2e='team-management_email_input' />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name='role'
                                rules={[...VALIDATION_RULES.REQUIRED]}
                                validateDebounce={validateDebounce}
                            >
                                <Select
                                    data-e2e='team-management_select-access_dropdown'
                                    label='Select Access'
                                    options={[
                                        {
                                            value: ACCOUNT_USER_ROLE.DEVELOPER,
                                            label: (
                                                <span data-e2e='team-management_developer_option'>
                                                    {ACCOUNT_USER_ROLE_LABELS[ACCOUNT_USER_ROLE.DEVELOPER].title}
                                                </span>
                                            )
                                        },
                                        {
                                            value: ACCOUNT_USER_ROLE.MEMBER,
                                            label: (
                                                <span data-e2e='team-management_member_option'>
                                                    {ACCOUNT_USER_ROLE_LABELS[ACCOUNT_USER_ROLE.MEMBER].title}
                                                </span>
                                            )
                                        },
                                        {
                                            value: ACCOUNT_USER_ROLE.ADMIN,
                                            label: (
                                                <span data-e2e='team-management_admin_option'>
                                                    {ACCOUNT_USER_ROLE_LABELS[ACCOUNT_USER_ROLE.ADMIN].title}
                                                </span>
                                            )
                                        }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Flex justify='end'>
                        <Flex gap={16}>
                            <Button onClick={onCancel} style={{ minWidth: 160 }} data-e2e='team-management_cancel_btn'>
                                Cancel
                            </Button>
                            <Button
                                htmlType='submit'
                                style={{ minWidth: 160 }}
                                type='primary'
                                data-e2e='team-management_save_btn'
                            >
                                Save
                            </Button>
                        </Flex>
                    </Flex>
                </Form>
            </Spin>
        </StyledCard>
    );
});

export default MemberForm;
